import {Component, Input, OnInit} from '@angular/core';
import {combineLatest, merge, Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, distinctUntilKeyChanged, filter, map, switchMap, take} from 'rxjs/operators';
import {DashboardLayersGeoBaseControlComponent} from '../dashboard-layers-geo-base-control.component';
import {Unit} from '../../unit';
import {LatLngBounds} from 'leaflet';
import {ProjectBusinessLogicFilterModel} from '../../../../shared/project-business-logic-filter/project-business-logic-filter.model';

@Component({
  selector: 'app-dashboard-unit-layers-geo-control',
  templateUrl: '../dashboard-layers-geo-base-control.component.html',
})
export class DashboardUnitLayersGeoControlComponent extends DashboardLayersGeoBaseControlComponent implements OnInit {
  @Input() unit: Observable<Unit>;
  @Input() startUnitPosition: [number, number];

  getRefreshTrigger(): Observable<[number, LatLngBounds, ProjectBusinessLogicFilterModel]> {
    return merge(
      this.unit.pipe(distinctUntilKeyChanged('id'), debounceTime(100)),
      this.projectBusinessLogicSyncFilterService.getFormattedProjectBusinessLogicFilter().pipe(distinctUntilChanged())
    ).pipe(
      debounceTime(100),
      switchMap(() => combineLatest([
        this.leafletBoundaryBox,
        this.projectBusinessLogicSyncFilterService.getFormattedProjectBusinessLogicFilter()
      ]).pipe(
        filter(([bbox, _]) => !!bbox),
        take(1)
      )),
      map(([bbox, pBFilter]) => [null, bbox, pBFilter] as [number, LatLngBounds, ProjectBusinessLogicFilterModel])
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadMapGeoData(false);
  }
}
